import React from "react";
import { BsExclamationDiamondFill } from "react-icons/bs";
import { HiOutlineCalendarDays } from "react-icons/hi2"; 
import ResumeUnderlineIconSVG from "assets/svg/resume-underline-icon";
import ResumeDotDividerIconSVG from "assets/svg/resume-dot-divider-icon";
import _ from "lodash";
import { formatDate } from "utils/utils";
import { CoverPlaceholderMilestone } from "constants/images";
import { useTranslation } from "react-i18next";

export default function ItemMilestone({
    tertiaryColor,
    show_image_milestone = true,
    items,
    headerType = 'featured',
    profile,
    primaryColor,
    fullPreview =  false,
    milestone_position=[]
  }) {
     const { t } = useTranslation();
  
    return (
          <>
           {/* featured, current and past milestones */}
            {items.some(element => element.type === headerType) &&
              !_.isEmpty(items) && (
                  <div className="w-full flex flex-col space-x-2 mb-4">
                    <div className="px-2 py-1.5 rounded-sm mb-4">
                      <p className="text-4xs font-medium text-lightBlack tracking-tight">
                      {
                          headerType === 'featured' ? 'Featured Milestones' :
                          headerType === 'current' ? 'Current Milestones'  : 'Past Milestones'
                      }
                      </p>
                      <ResumeUnderlineIconSVG
                        className="mt-3"
                        stroke={primaryColor}
                      />
                    </div> 
                        {items.map((mf, i) => (
                          mf?.type === headerType &&
                          <div
                            key={`featured-${i}`}
                            className="mb-2 pr-2 flex flex-row space-x-2.6 items-center">
                            {show_image_milestone && 
                            <div className={`bg-default rounded relative h-[130px] w-[130px] flex items-center justify-center`}>
                              <div className={`relative flex items-center justify-center h-[130px] w-[130px]`}>
                                {mf.thumbnail ? (
                                  <img
                                    alt="milestones"
                                    src={mf.thumbnail.url}
                                    className={`h-[130px] object-contain object-center`}
                                  />
                                ) :
                                  <div className="flex justify-center items-center h-[130px]">
                                    <img
                                      alt="milestones"
                                      src={CoverPlaceholderMilestone}
                                      className="w-[50%] object-contain object-center"
                                    />
                                  </div>
                                }
                              </div>
                            </div>}
                            {/* style={{ width: "calc(100% - 111px)" }} */}
                            <div className="w-full">
                              {/* title and date */}
                              <div className="w-full">
                                <div className="w-full flex flex-row items-center justify-between">
                                  {/* title */}
                                  <div className="flex flex-row items-center space-x-1">
                                    <p className="text-4xs text-lightBlack font-semibold tracking-tight">
                                      {mf?.title}
                                    </p>
                                    <span
                                      className="uppercase px-1 py-0.5 rounded-sm text-5xs font-bold text-white"
                                      style={{
                                        backgroundColor: tertiaryColor,
                                      }}>
                                      {mf?.category?.name}
                                    </span>
                                  </div>
                                  {/* date */}
                                  <div>
                                    <p className="text-3xs text-darkerGray font-medium tracking-resume leading-1 flex flex-row space-x-1">
                                      <HiOutlineCalendarDays className="w-2 h-2 text-darkerGray" />
                                      {formatDate(mf,profile?.dateFormat,t)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {/* sub title and episodes */}
                              <div className="w-full leading-none">
                                <span style={{ color: primaryColor }} className="text-7xs font-medium">
                                    {mf?.positions && mf?.positions
                                      .filter(item =>
                                        !milestone_position.some(hide =>
                                          hide?.[mf?.id]?.includes(item.position_id)
                                        )
                                      ).map((p) => {
                                        const _pos = [p.position.name?.trim()];
                                        if (p.description)
                                          _pos.push((p.description).trim());
                                        return _pos.join(" - ");
                                      })
                                      .join(", ")
                                      .trim()}
                                </span>
                                {mf?.platform && (
                                    <span style={{ color: primaryColor }} className="text-7xs font-semibold">{` (${mf?.platform})`}</span>
                                  )}
                                  {mf?.date_note && (
                                    <>
                                      <span style={{ color: primaryColor }} className="text-7xs text-darkerGray opacity-30">
                                        &#8226;
                                      </span>
                                      <span style={{ color: primaryColor }} className="text-7xs font-semibold">
                                        {mf?.date_note}
                                      </span>
                                    </>
                                  )}
                              </div>
                              {/* description */}
                              <div className="w-full mt-1">
                                {
                                  mf?.description && mf?.description !== 'null' &&
                                  <div
                                    className={`text-darkerGray tracking-resume line-clamp-7 ${fullPreview ? "text-4xs leading-[11px]" : " leading-[7px] text-3xs"}`}
                                    dangerouslySetInnerHTML={{
                                      __html: mf?.description,
                                    }}></div>
                                }
                              </div>
                            </div>
                          </div>
                        ))}
                  
                  {/* Divider */}
                  <div className="w-full py-4">
                    <ResumeDotDividerIconSVG full={true} />
                  </div>
                  </div>
              )} 
          </>  
    );
  }